import React, { useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import PostHooks from "../../../../Api/PostHooks";
import { LoadingButton } from "@mui/lab";
import AlertComponent from "../../../../Components/AlertComponent";

const UnblockUserForm = ({ user, onClose, onSuccess }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [loading, response, request] = PostHooks();

  const handleSubmit = async () => {
    try {
      const payload = { username: user.id_number };
      // Dummy API call
      const lockResp = await request({ url: "/unlock_account", body: payload });

      if (
        lockResp &&
        lockResp.status === 200 &&
        lockResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Unblocked successfully!",
        });

        setTimeout(() => {
          if (onSuccess) {
            onSuccess();
          }
          onClose();
        }, 1000);
      } else {
        const errorMessage =
          lockResp?.data?.StatusMessage ??
          lockResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <Box>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Typography>Are you sure you want to unblock this user?</Typography>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <LoadingButton
          onClick={handleSubmit}
          loading={loading}
          variant="contained"
          color="secondary"
        >
          Unblock User
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default UnblockUserForm;
